module.exports = __webpack_public_path__ + "img/Weapon_278.6d3199b8.png";